import React, { useState } from "react";
import "./header.scss";
import { Link, useNavigate } from "react-router-dom";
import mainLogoImg from "../../assets/header/mainLogo.png";
import logoImg1 from "../../assets/header/logo1.png";
import logoImg2 from "../../assets/header/logo2.png";
import miniLogoImg from "../../assets/header/miniImg.png";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseIcon from "@mui/icons-material/Close";
import groomProfileImg from "../../assets/header/profileGroom.svg";

const menu = [
  { name: "Home", url: "/home", isActive: true },
  { name: "Search", url: "/search", isActive: false },
  { name: "Terms", url: "/terms", isActive: false },
  { name: "Registration", url: "/register", isActive: false },
  { name: "Profile", url: "/profiles", isActive: false },
  { name: "Committee", url: "/committee", isActive: false },
  { name: "Committee Contribution", url: "/committeeContribution", isActive: false },
  { name: "Events & Blogs", url: "/events", isActive: false },
  { name: "Contact Us", url: "/contact", isActive: false },
  { name: "Success Stories", url: "/successstories", isActive: false },
  { name: "Help", url: "/help", isActive: false },
  { name: "My Profile", url: "/myProfile", isActive: false },
];

const Header = () => {
  let navigate = useNavigate();
  const [showPhoneMenu, setShowPhoneMenu] = useState(false);
  const [mainTabMenu, setMainTabMenu] = useState(menu);
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const setActiveTab = (value) => {
    let temp = menu;
    temp.map((item) => {
      if (value === item.name) item.isActive = true;
      else item.isActive = false;
    });
    setMainTabMenu(temp);
  };

  return (
    <header className="headerContainer">
      <div className="header">
        <div className=" p-1 row headerWrapper">
          <div className="col d-flex align-items-center justify-content-start pl-4">
            <div className="row ">
              <div className="col pr-3 position-relative">
                <img alt="" src={logoImg1} className="width55percent" />
                <span className="text-blackcurrant align-self-end">
                  Powered by UCSI
                </span>
              </div>
            </div>
          </div>
          <div className="col d-flex align-items-center justify-content-center">
            <img alt="" src={mainLogoImg} className="mainLogoImg" />
          </div>
          <div className="col d-flex align-items-center justify-content-end pr-4">
            <img alt="" src={logoImg2} className="width40percent" />
            <img alt="" className="miniLogoImg" src={miniLogoImg} />
          </div>
        </div>
      </div>
      <div className="phoneHeader pl-3">
        <div className="d-inline-block">
          <img alt="" src={logoImg1} className="mainLogo" />
          <span className="text-blackcurrant pl-2 font10px">
            Powered by UCSI
          </span>
        </div>
        <div className="d-inline-block phoneHeaderImg">
          <img alt="" src={logoImg2} />
        </div>
        <div className="d-inline-block">
          <img alt="" className="miniLogoImg" src={miniLogoImg} />
        </div>
      </div>
      <div className="headerOptionsContainer d-flex justify-content-between">
        <span className="align-self-center">
          {mainTabMenu?.map((item, index) => {
            return (
              <>
                {item.name !== "Profile" ? (
                  <>
                    {item.name === "My Profile" &&
                    localStorage.getItem("userLoggedIn") !== "Yes" ? (
                      <span></span>
                    ) : (
                      <span
                        className={item.isActive ? "active" : "inactive"}
                        key={index}
                        onClick={() => {
                          setActiveTab(item.name);
                        }}
                      >
                        <Link to={item.url}>{item.name}</Link>
                      </span>
                    )}
                  </>
                ) : (
                  <div className="position-relative d-inline-block">
                    <span
                      className={
                        item.isActive
                          ? "active cursorPointer"
                          : "inactive cursorPointer"
                      }
                      key={index}
                      onClick={() => {
                        setActiveTab(item.name);
                        setShowProfileOptions(true);
                      }}
                    >
                      Profiles
                      {/* <Link to={item.url}>{item.name}</Link> */}
                    </span>
                    {showProfileOptions && (
                      <div className="profileTypesContainer p-3">
                        <label className="text-white font-bold">
                          New Candidates
                        </label>
                        <div className="profileTypeSection">
                          <span
                            className="profileType p-2 mr-3"
                            onClick={() => {
                              setActiveTab("Profile");
                              setShowProfileOptions(false);
                              navigate("/profiles/unmarried/male");
                            }}
                          >
                            <img src={groomProfileImg} alt="" /> Groom
                          </span>
                          <span
                            className="profileType p-2"
                            onClick={() => {
                              setActiveTab("Profile");
                              setShowProfileOptions(false);
                              navigate("/profiles/unmarried/female");
                            }}
                          >
                            <img src={groomProfileImg} alt="" />
                            Bride
                          </span>
                        </div>
                        <label className="text-white font-bold mt-2">
                          Divorce
                        </label>
                        <div className="profileTypeSection">
                          <span
                            className="profileType p-2 mr-3"
                            onClick={() => {
                              setActiveTab("Profile");
                              setShowProfileOptions(false);
                              navigate("/profiles/divorcee/male");
                            }}
                          >
                            <img src={groomProfileImg} alt="" />
                            Groom
                          </span>
                          <span
                            className="profileType p-2"
                            onClick={() => {
                              setActiveTab("Profile");
                              setShowProfileOptions(false);
                              navigate("/profiles/divorcee/female");
                            }}
                          >
                            <img src={groomProfileImg} alt="" />
                            Bride
                          </span>
                        </div>
                        <label className="text-white font-bold mt-2">
                          Widowed
                        </label>
                        <div>
                          <span
                            className="profileType p-2 mr-3"
                            onClick={() => {
                              setActiveTab("Profile");
                              setShowProfileOptions(false);
                              navigate("/profiles/widowed/male");
                            }}
                          >
                            <img src={groomProfileImg} alt="" />
                            Groom
                          </span>
                          <span
                            className="profileType p-2"
                            onClick={() => {
                              setActiveTab("Profile");
                              setShowProfileOptions(false);
                              navigate("/profiles/widowed/female");
                            }}
                          >
                            <img src={groomProfileImg} alt="" />
                            Bride
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            );
          })}
        </span>
        <span
          className="align-self-center phoneMenuOption"
          onClick={() => {
            setShowPhoneMenu(!showPhoneMenu);
          }}
        >
          <MenuOutlinedIcon />
        </span>
        <span>
          {localStorage.getItem("userLoggedIn") !== "Yes" ||
          localStorage.getItem("userLoggedIn") === null ? (
            <span
              className="loginBtn d-flex"
              onClick={() => {
                let temp = menu;
                temp.map((item) => {
                  item.isActive = false;
                });
                setMainTabMenu(temp);
              }}
            >
              <Link to="/login">LOGIN</Link>
            </span>
          ) : (
            <span
              className="loginBtn d-flex"
              onClick={() => {
                localStorage.setItem("userLoggedIn", "No");
                setActiveTab("Home");
                localStorage.clear();
              }}
            >
              <Link to="/">LOGOUT</Link>
            </span>
          )}
        </span>
      </div>
      {showPhoneMenu && (
        <div className="phoneMenu">
          <span
            className="text-right pr-1 d-block"
            onClick={() => {
              setShowPhoneMenu(false);
            }}
          >
            <CloseIcon />
          </span>
          <ul className="pl-2">
            {menu?.map((item, index) => {
              return (
                <>
                  {item.name !== "Profile" ? (
                    <>
                      {item.name === "My Profile" &&
                      localStorage.getItem("userLoggedIn") !== "Yes" ? (
                        <span></span>
                      ) : (
                        <li
                          key={index}
                          className={item.isActive ? "active" : "inactive"}
                          onClick={() => {
                            setActiveTab(item.name);
                          }}
                        >
                          <Link to={item.url}>{item.name}</Link>
                        </li>
                      )}
                    </>
                  ) : (
                    <>
                      <li
                        key={index}
                        className={item.isActive ? "active" : "inactive"}
                        onClick={() => {
                          setActiveTab(item.name);
                          setShowProfileOptions(true);
                        }}
                      >
                        Profiles
                        {/* <Link to={item.url}>{item.name}</Link> */}
                      </li>
                      {showProfileOptions && (
                        <div className="p-2">
                          <div className="phoneProfiles mb-2">
                            <label className="textDarkRed text-center d-block font-block p-1">
                              New Candidates
                            </label>
                            <div className="d-flex flex-row p-1">
                              <span
                                className="p-1 text-center d-inline-block flex-grow-1"
                                onClick={() => {
                                  navigate("/profiles/unmarried/male");
                                }}
                              >
                                Groom
                              </span>
                              <span
                                className="p-1 text-center d-inline-block flex-grow-1"
                                onClick={() => {
                                  navigate("/profiles/unmarried/female");
                                }}
                              >
                                Bride
                              </span>
                            </div>
                          </div>
                          <div className="phoneProfiles mb-2">
                            <label className="textDarkRed text-center d-block font-block p-1">
                              Divorce
                            </label>
                            <div className="d-flex flex-row p-1">
                              <span
                                className="p-1 text-center d-inline-block flex-grow-1"
                                onClick={() => {
                                  navigate("/profiles/divorcee/male");
                                }}
                              >
                                Groom
                              </span>
                              <span
                                className="p-1 text-center d-inline-block flex-grow-1"
                                onClick={() => {
                                  navigate("/profiles/divorcee/female");
                                }}
                              >
                                Bride
                              </span>
                            </div>
                          </div>
                          <div className="phoneProfiles">
                            <label className="textDarkRed text-center d-block font-block p-1">
                              Widowed
                            </label>
                            <div className="d-flex flex-row p-1">
                              <span
                                className="p-1 text-center d-inline-block flex-grow-1"
                                onClick={() => {
                                  navigate("/profiles/widowed/male");
                                }}
                              >
                                Groom
                              </span>
                              <span
                                className="p-1 text-center d-inline-block flex-grow-1"
                                onClick={() => {
                                  navigate("/profiles/widowed/female");
                                }}
                              >
                                Bride
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              );
            })}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
